import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/parcels";

export const applyParcel = (params: {}) => alertRequest(`${resource}/applyParcel`, body(params));
export const applyRussianPostStatus = (params: {}) => alertRequest(`${resource}/applyRussianPostStatus`, body(params));
export const applyCdekStatus = (params: {}) => alertRequest(`${resource}/applyCdekStatus`, body(params));
export const updateParcelStatus = (params: {}) => request(`${resource}/updateParcelStatus`, body(params));
export const setParcelPlannedDeliveryDate = (params: {}) =>
    request(`${resource}/setParcelPlannedDeliveryDate`, body(params));
export const deleteParcel = (params: {}) => request(`${resource}/deleteParcel`, body(params));
export const getStatusListForSelect = (params: {}) =>
    request(`${resource}/getStatusListForSelect${containsQuery(params)}`, { method: "GET" });
export const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter } });
    return request(`${resource}/getStatusList${query}`, { method: "GET" }, { countInHeaders: true });
};
export const delItem = (params: {}) => alertRequest(`${resource}/deleteStatus`, body(params));
export const getCdekStatus = ({ id }: { id: number }) => request(`${resource}/getCdekStatus/${id}`, { method: "GET" });
export const getRussianPostStatus = ({ id }: { id: number }) =>
    request(`${resource}/getRussianPostStatus/${id}`, { method: "GET" });
export const getParcelStatuses = (id: number) => request(`${resource}/getParcelStatuses/${id}`, { method: "GET" });
